export interface ICollapseInfo {
  key: string;
  header: string;
  data: any[];
}
interface IClassifier {
  [key: string]: any[];
}

export const classifyDataByKey = (
  dataSource: any[],
  key: string,
  header: string,
): ICollapseInfo[] => {
  const classifier: IClassifier = {};
  for (const item of dataSource) {
    if (typeof item[key] !== 'number' && !item[key]) {
      continue;
    }
    const classifierKey =  String(item[key]);
    if (classifier[classifierKey]) {
      classifier[classifierKey].push(item);
    } else {
      classifier[classifierKey] = [item];
    }
  }
  const result: ICollapseInfo[] = [];
  Object.keys(classifier).forEach((classifierKey) => {
    result.push({
      key: classifierKey,
      header: classifier[classifierKey][0][header] || classifierKey,
      data: classifier[classifierKey],
    });
  });
  return result;
};
export const mergeClassifiedData = (dataSource: ICollapseInfo[], mergeData: ICollapseInfo[]): ICollapseInfo[] => {
  const defaultData = JSON.parse(JSON.stringify(dataSource)) as ICollapseInfo[];
  const newData = JSON.parse(JSON.stringify(mergeData)) as ICollapseInfo[];
  const result: ICollapseInfo[] = [];
  const resultKeys: string[] = [];
  // 把dataSource 加入到result
  defaultData.forEach((classifyItem) => {
    const findResult = newData.find((item) => item.key === classifyItem.key);
    if (findResult) {
      classifyItem.data = findResult.data;
    }
    result.push(classifyItem);
    resultKeys.push(classifyItem.key);
  });
  newData.forEach((classifyItem) => {
    if (!resultKeys.includes(classifyItem.key)) {
      result.push(classifyItem);
    }
  });
  return result;
};
export const generateClassifications = (
  dataSource: any[],
  key: string,
  headerKey: string,
): ICollapseInfo[] => {
  return dataSource.map((item) => ({
    key: item[key],
    header: item[headerKey],
    data: [],
  }));
};
